import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFiltrosPluginsInforme } from "../../actions/informes";

const InformesMenu = (props) => {
  const dispatch = useDispatch();
  const informes = useSelector((state) => state.informes.informes);
  const informe_seleccionado = useSelector((state) => state.informes.informe_seleccionado)

  const onClick = (e) => {
    e.preventDefault();
    if (e.target.dataset.informe) {
      dispatch(getFiltrosPluginsInforme(e.target.dataset.informe));
      props.setPlugginState(false);
    }
  };

  const cargaHijosMenu = (informe) => {
    if (informes.filter((inf) => inf.cod_padre === informe.codigo_menu).reduce((accumulator, currentValue) => accumulator + 1, 0) > 0) {
      return (
        <div className="dropdown-menu">
          <div className="row tt-col-list">
            <div className="col">
              <ul className="tt-megamenu-submenu tt-sub-img">
                {informes.map((hijo, hijo_index) => {
                  if (hijo.cod_padre === informe.codigo_menu) {
                    return (
                      <li key={hijo_index}>
                        <a href="/#"
                          data-informe={hijo.nombre_informe}
                          onClick={onClick}>
                          {hijo.nombre}
                        </a>
                      </li>
                    );
                  }
                  return "";
                })}
              </ul>
            </div>
          </div>
        </div>
      );
    } else return "";
  };

  return (
    <Fragment>
      <header className="menu-informes">
        <div className="tt-color-scheme-01">
          <div className="container">
            <nav>
              <ul className="listado_tipos_informes">
                {informes && Array.isArray(informes)
                  ? informes.map((informe, index) => {
                    if (informe.nivel === "1") {
                      return (
                        <li key={index} className="dropdown tt-megamenu-col-02 tt-submenu">
                          <a href="/#"
                            data-informe={informe.nombre_informe}
                            onClick={onClick}
                            style={
                              informe_seleccionado === informe.nombre_informe ? { fontWeight: 'bold' }
                                : null
                            }>
                            {informe.nombre.toUpperCase()}
                          </a>
                          {informes && Array.isArray(informes) ? cargaHijosMenu(informe) : ""}
                        </li>
                      );
                    }
                    return "";
                  })
                  : ""}
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </Fragment>
  );
};

export default InformesMenu;
